import React from 'react'

import WhatsappIcon from 'assets/icons/WhatsappIcon';

function WhatsappButton() {

    return (
        <div className='fixed bottom-0 right-0 z-50 flex flex-col items-end justify-end gap-4 mb-4 mr-4 chat-widget md:mr-8 md:mb-8 drop-shadow-md'>
            <button
                className='flex items-center justify-center w-10 h-10 transition-all rounded-full bg-app-blue-light md:h-14 md:w-14 drop-shadow-md md:hover:-translate-y-1'
                onClick={() => window.open(`https://wa.me/+6285158774198`, "_blank")}
            >
                <WhatsappIcon className="w-5 h-5 md:h-7 md:w-7 fill-black" />
            </button>
        </div>
    )
}

export default WhatsappButton;